"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_consumables_1 = require("../types/node-consumables");
const util_1 = require("../util");
const { GET, PUT, DELETE } = util_1.httpMethods;
/**
 * @classdesc Represents the class interfacing node consumables related API-I endpoints
 * @class
 */
class NodeConsumables {
    constructor(api) {
        this.api = api;
    }
    /**
     * Get node consumables status according to the parameters provided
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#node-consumables-status-get}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an object of data or an error with the problem
     */
    async getNodeConsumableStatus(args) {
        const { nodeIdentifier, lastService } = args || {};
        const methodName = 'getNodeConsumableStatus';
        // validate
        const promises = [
            (0, util_1.validateParam)(methodName, 'nodeIdentifier', nodeIdentifier, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'nodeIdentifier', nodeIdentifier, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'lastService', lastService, util_1.ValidationTypes.STRING),
        ];
        (0, util_1.validateParams)(promises);
        if (!nodeIdentifier) {
            throw (0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)('The nodeIdentifier is not provided.'));
        }
        const route = `/nodes/consumables/${nodeIdentifier}/status`;
        const input = {
            query: {
                lastService,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(GET, route, formattedInput);
    }
    /**
     * Set node consumables status according to the parameters provided
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#node-consumables-set}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an object of data or an error with the problem
     */
    async setNodeConsumables(args) {
        const { nodeType, nodeIdentifiers, consumableTypes, lureIds, customerId } = args || {};
        const methodName = 'setNodeConsumables';
        // validate
        const promises = [
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.INTEGER),
            (0, util_1.validateParam)(methodName, 'nodeType', nodeType, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'nodeType', nodeType, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'nodeIdentifiers', nodeIdentifiers, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'nodeIdentifiers', nodeIdentifiers, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'lureIds', lureIds, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.NUMBER),
        ];
        (0, util_1.validateParams)(promises);
        if (consumableTypes.includes(node_consumables_1.ConsumableType.LURE) && !lureIds) {
            throw (0, util_1.createJSONStringifiedError)((0, util_1.setErrResponse)('The lure(s) are not provided.'));
        }
        const route = `/nodes/${nodeType.toLowerCase()}/consumables`;
        const input = {
            header: {
                customerId,
            },
            body: {
                nodeIdentifiers,
                consumableTypes,
                lureIds,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(PUT, route, formattedInput);
    }
    /**
     * Remove node consumables status according to the parameters provided
     * @see {@link https://noc2-stage.semios.com/api-internal-docs#node-consumables-set}
     * @param {Object} args={} - An object containing the arguments accepted by the API
     * @return {promise} Assets - Returns a Promise that, when fulfilled, will either return an object of data or an error with the problem
     */
    async removeNodeConsumables(args) {
        const { nodeType, nodeIdentifiers, consumableTypes, customerId } = args || {};
        const methodName = 'removeNodeConsumables';
        // validate
        const promises = [
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'customerId', customerId, util_1.ValidationTypes.INTEGER),
            (0, util_1.validateParam)(methodName, 'nodeType', nodeType, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'nodeType', nodeType, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'nodeIdentifiers', nodeIdentifiers, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'nodeIdentifiers', nodeIdentifiers, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.PRESENCE),
            (0, util_1.validateParam)(methodName, 'consumableTypes', consumableTypes, util_1.ValidationTypes.ARRAY, util_1.ValidationTypes.STRING),
        ];
        (0, util_1.validateParams)(promises);
        const route = `/nodes/${nodeType.toLowerCase()}/consumables`;
        const input = {
            header: {
                customerId,
            },
            body: {
                nodeIdentifiers,
                consumableTypes,
            },
        };
        const formattedInput = (0, util_1.setFormattedInput)(input);
        return this.api.send(DELETE, route, formattedInput);
    }
}
exports.default = NodeConsumables;
//# sourceMappingURL=node-consumables.js.map